import { EDIT_DRIVER_LOCATION_FAILURE, EDIT_DRIVER_LOCATION_REQUEST, EDIT_DRIVER_LOCATION_SUCCESS, HOLD_DUTY_FAILURE, HOLD_DUTY_REQUEST, HOLD_DUTY_SUCCESS, MAKE_CAB_AVAILABLE_FAILURE, MAKE_CAB_AVAILABLE_REQUEST, MAKE_CAB_AVAILABLE_SUCCESS, RELEASE_HOLD_CAB_FAILURE, RELEASE_HOLD_CAB_REQUEST, RELEASE_HOLD_CAB_RESET, RELEASE_HOLD_CAB_SUCCESS, RESUME_DUTY_CAB_FAILURE, RESUME_DUTY_CAB_REQUEST, RESUME_DUTY_CAB_SUCCESS } from "../actions/driverAttendenceAction";

interface DriverAttendanceState {
    drivers: any[];
    loadingDrivers: boolean;
    loading: boolean;
    logoutLoading: boolean;
    logoutMessage: string | null;
    logoutError: string | null;
    leaveLoading: boolean;
    leaveMessage: string | null;
    leaveError: string | null;
    revertLogoutLoading: boolean;
    revertLogoutMessage: string | null;
    revertLogoutError: string | null;
    revertLoginLoading: boolean;
    revertLoginMessage: string | null;
    revertLoginError: string | null;
    holdLoading: boolean;
    holdMessage: string | null;
    holdError: string | null;
    logoutDetails: any | null;
    releaseLoading: boolean;
    releaseMessage: string | null;
    releaseError: string | null;
    resumeDutyLoading: boolean;
    resumeDutyMessage: string | null;
    resumeDutyError: string | null;
    editLocationLoading: boolean;
    editLocationMessage: string | null;
    editLocationError: string | null;
    message: string | null;
    error: string | null;
    data: any | null;
}

const initialState: DriverAttendanceState = {
    drivers: [],
    loadingDrivers: false,
    logoutLoading: false,
    logoutMessage: null,
    leaveLoading: false,
    leaveMessage: null,
    leaveError: null,
    logoutError: null,
    revertLogoutLoading: false,
    revertLogoutMessage: null,
    revertLogoutError: null,
    revertLoginLoading: false,
    revertLoginMessage: null,
    revertLoginError: null,
    logoutDetails: null,
    holdLoading: false,
    holdMessage: null,
    holdError: null,
    releaseLoading: false,
    releaseMessage: null,
    releaseError: null,
    resumeDutyLoading: false,
    resumeDutyMessage: null,
    resumeDutyError: null,
    editLocationLoading: false,
    editLocationMessage: null,
    editLocationError: null,
    loading: false,
    message: null,
    error: null,
    data: null,
};

const driverAttendanceReducer = (state = initialState, action: any): DriverAttendanceState => {
    switch (action.type) {
        case "GET_DRIVER_ATTENDANCE_REQUEST":
            return { ...state, loadingDrivers: true, error: null };

        case "GET_DRIVER_ATTENDANCE_SUCCESS":
            return {
                ...state,
                loadingDrivers: false,
                drivers: action.payload,
                error: null,
            };

        case "GET_DRIVER_ATTENDANCE_FAILURE":
            return { ...state, loadingDrivers: false, error: action.payload };

        case "APPROVE_ATTENDANCE_REQUEST":
            return { ...state, loading: true, error: null, message: null };

        case "APPROVE_ATTENDANCE_SUCCESS":
            return { ...state, loading: false, message: action.payload, error: null };

        case "APPROVE_ATTENDANCE_FAILURE":
            return { ...state, loading: false, error: action.payload, message: null };

        case "CLEAR_ATTENDANCE_MESSAGE":
            return {
                ...state,
                message: null,
                error: null,
                logoutMessage: null,
                logoutError: null,
                leaveMessage: null,
                leaveError: null,
                revertLogoutMessage: null,
                revertLogoutError: null,
                revertLoginMessage: null,
                revertLoginError: null,
                holdMessage: null,
                holdError: null,
                resumeDutyMessage: null,
                resumeDutyError: null,
                editLocationMessage: null,
                editLocationError: null,
            };

        case "APPROVE_LOGOUT_REQUEST":
            return { ...state, logoutLoading: true, error: null, message: null };

        case "APPROVE_LOGOUT_SUCCESS":
            return { ...state, logoutLoading: false, logoutMessage: action.payload, logoutError: null };

        case "APPROVE_LOGOUT_FAILURE":
            return { ...state, logoutLoading: false, logoutError: action.payload, logoutMessage: null };

        case "LEAVE_APPROVE_REQUEST":
            return { ...state, leaveLoading: true, error: null, message: null };

        case "LEAVE_APPROVE_SUCCESS":
            return { ...state, leaveLoading: false, leaveMessage: action.payload, leaveError: null };

        case "LEAVE_APPROVE_FAILURE":
            return { ...state, leaveLoading: false, leaveError: action.payload, leaveMessage: null };

        case "REVERT_LOGOUT_REQUEST":
            return { ...state, revertLogoutLoading: true, revertLogoutError: null, revertLogoutMessage: null };

        case "REVERT_LOGOUT_SUCCESS":
            return { ...state, revertLogoutLoading: false, revertLogoutMessage: action.payload, revertLogoutError: null };

        case "REVERT_LOGOUT_FAILURE":
            return { ...state, revertLogoutLoading: false, revertLogoutError: action.payload, revertLogoutMessage: null };

        case "REVERT_LOGIN_REQUEST":
            return { ...state, revertLoginLoading: true, revertLoginError: null, revertLoginMessage: null };

        case "REVERT_LOGIN_SUCCESS":
            return { ...state, revertLoginLoading: false, revertLoginMessage: action.payload, revertLoginError: null };

        case "REVERT_LOGIN_FAILURE":
            return { ...state, revertLoginLoading: false, revertLoginError: action.payload, revertLoginMessage: null };

        case "GET_LOGOUT_DETAILS_REQUEST":
            return { ...state, loading: true, error: null, logoutDetails: null };

        case "GET_LOGOUT_DETAILS_SUCCESS":
            return { ...state, loading: false, logoutDetails: action.payload, error: null };

        case "GET_LOGOUT_DETAILS_FAILURE":
            return { ...state, loading: false, error: action.payload };

        case HOLD_DUTY_REQUEST:
            return { ...state, holdLoading: true, holdMessage: null, holdError: null };

        case HOLD_DUTY_SUCCESS:
            return { ...state, holdLoading: false, holdMessage: action.payload };

        case HOLD_DUTY_FAILURE:
            return { ...state, holdLoading: false, holdError: action.payload };

        case RELEASE_HOLD_CAB_REQUEST:
            return { ...state, releaseLoading: true, releaseMessage: null, releaseError: null };

        case RELEASE_HOLD_CAB_SUCCESS:
            return { ...state, releaseLoading: false, releaseMessage: action.payload, releaseError: null };

        case RELEASE_HOLD_CAB_FAILURE:
            return { ...state, releaseLoading: false, releaseError: action.payload, releaseMessage: null };

        case RELEASE_HOLD_CAB_RESET:
            return { ...state, releaseLoading: false, releaseMessage: null, releaseError: null };

        case RESUME_DUTY_CAB_REQUEST:
            return { ...state, resumeDutyLoading: true, resumeDutyMessage: null, resumeDutyError: null };

        case RESUME_DUTY_CAB_SUCCESS:
            return { ...state, resumeDutyLoading: false, resumeDutyMessage: action.payload, resumeDutyError: null };

        case RESUME_DUTY_CAB_FAILURE:
            return { ...state, resumeDutyLoading: false, resumeDutyError: action.payload, resumeDutyMessage: null };

        case EDIT_DRIVER_LOCATION_REQUEST:
            return { ...state, editLocationLoading: true, editLocationMessage: null, editLocationError: null };

        case EDIT_DRIVER_LOCATION_SUCCESS:
            return {
                ...state,
                editLocationLoading: false,
                editLocationMessage: action.payload?.message || "Location updated successfully",
                editLocationError: null,
            };

        case EDIT_DRIVER_LOCATION_FAILURE:
            return {
                ...state,
                editLocationLoading: false,
                editLocationMessage: null,
                editLocationError: action.payload?.message || action.payload || "Failed to update location",
            };

        case MAKE_CAB_AVAILABLE_REQUEST:
            return { ...state, loading: true, error: null };
        case MAKE_CAB_AVAILABLE_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case MAKE_CAB_AVAILABLE_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
};

export default driverAttendanceReducer;
